/* eslint-disable */
import Cookies from 'js-cookie';
import Sticky from 'sticky-js';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Disturber Home

*/

$(function() {
    const $disturberContainer = $('.disturber__container');
    const $disturberContent = $('.disturber__content-container');
    const $disturber = $('#disturber');
    const $disturberBuffer = $('.disturber__buffer');
    const $disturberCloseBtn = $disturber.find('.disturber__close');
    const $siteHeader = $('.site-header');
    const $siteHeaderBuffer = $('.site-header-buffer');
    const cookieName = 'disturber_hidden';
    let disturberHeight = $disturber.outerHeight();
    const cookie = Cookies.get(cookieName); // get cookie

    // hide disturber container when it has no content
    if ($disturberContent.children().length === 0) {
        $disturberContainer.addClass('hidden');
        $siteHeader.removeClass('compact-mode site-header--disturber');
        $disturberBuffer.height(0);
    }

    $disturberCloseBtn.on('click', function() {
        $disturber.addClass('disturber--hidden');
        $siteHeader.removeClass('compact-mode site-header--disturber');
        $disturberBuffer.height(0);
        $siteHeader.css('top', 0);
        $(window).trigger('initHeader');

        if ($('body').hasClass('tpl-site-header-buffer-enabled') === true) {
            $siteHeaderBuffer.css('display', 'block');
        }

        // set cookie
        Cookies.set(cookieName, 'true', { expires: 365, path: '/' });
    });

    function initDisturberSticky() {
        const isMobile = window.matchMedia("only screen and (max-width: 576px)").matches;
        const isTablet = window.matchMedia("only screen and (max-width: 768px)").matches;
        disturberHeight = $disturber.outerHeight();

        if (!cookie && isTablet) { // on mobile
            new Sticky('.site-header');

            if (isMobile) {
                if ($('body').hasClass('tpl-site-header-buffer-enabled') === false && $disturber.hasClass('disturber-hidden') === false) {
                    $siteHeaderBuffer.css('display', 'none');
                }
                $(window).on('scroll', function() {
                    if ($('body').hasClass('tpl-site-header-buffer-enabled') === false) {
                        if (window.scrollY > disturberHeight + 1) {
                            $siteHeaderBuffer.css('display', 'block');
                        } else {
                            $siteHeaderBuffer.css('display', 'none');
                        }
                    }
                });
            }
        }
        else { // on desktop
            $disturberBuffer.height(disturberHeight);
            $siteHeader.css('top', disturberHeight);
        }
    }

    $(window).on('viewportWidthHasChanged', function() {
        initDisturberSticky();
    });

    initDisturberSticky();

});



// WEBPACK FOOTER //
// ./static/js/modules/disturber.js